var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenbrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.416 15.3887L18.3984 6.39746C18.3984 6.01953 18.1523 5.75586 17.7568 5.75586H8.76562C8.3877 5.75586 8.1416 6.03711 8.1416 6.35352C8.1416 6.67871 8.41406 6.94238 8.73926 6.94238H12.5449L16.5967 6.83691L15.0498 8.24316L5.75977 17.542C5.63672 17.665 5.5752 17.8145 5.5752 17.9639C5.5752 18.2803 5.86523 18.5791 6.19043 18.5791C6.33984 18.5791 6.48926 18.5264 6.6123 18.3945L15.9111 9.10449L17.3174 7.55762L17.2119 11.1787V15.415C17.2119 15.7314 17.4756 16.0215 17.8096 16.0215C18.1348 16.0215 18.416 15.749 18.416 15.3887Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenbrowser);
export default __webpack_public_path__ + "static/media/Open browser.297908426ed6a063a7dae5c683414865.svg";
export { ForwardRef as ReactComponent };